export const API_URL = process.env.VUE_APP_API_URL;
export const SEARCH_URL = process.env.VUE_APP_SEARCH_API_URL;
export const USER_URL = process.env.VUE_APP_USER_API_URL;

export const DOMAIN_TITLE = 'Dio Admin';
